module.exports = __webpack_public_path__ + "static/media/01A.b376a03e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/01A.png
// module id = 249
// module chunks = 0